export default "__VITE_ASSET__Dyp0$JoI__"